import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

// import '../styles.less'
import SidebarProposal from '../../layouts/sidebarProposal/SidebarProposal'
import GranteePropertyWidgets from '../../widgets/projectProposal/granteeProperty/GranteePropertyWidgets'
import BtnEditAll from '../../components/buttons/btnEditAll/BtnEditAll'
import ErrorWidget from '../../widgets/errorWidget/ErrorWidget'
import PanalLoadingTemplate from '../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../utils/loading'
import { getInfomaDocumentPage } from '../../redux/actions/infomaDocument'
import { getIsEditAll, setIsEditAll, handleOnChangeIsEdit } from '../../utils/widget'
import ContentHeader from '../../components/ContentHeader/ContentHeader'
import pathname from '../../constants/pathname'
import AttachFilesGranteeContract from '../../widgets/makeContract/AttachFilesGranteeContract'
import { Panel } from 'rsuite'
import InfomaUploadFilesWidget from '../../widgets/infomaWidget/InfomaUploadFilesWidget'

export default function InfomaUploadFiles() {
  const [isEditWidget, setIsEditWidget] = useState({})
  const [schema, setSchema] = useState()
  const [error, setError] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [showEditAll, setShowEditAll] = useState()

  const [isEditErr, setIsEditErr] = useState(false)
  const [isUploadErr, setIsUploadErr] = useState(false)
  const [isDeleteError, setIsDeleteError] = useState(false)
  const [isGranteeFileError, setIsGranteeFileError] = useState(false)

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const buttonRoute = {
    pathNameBackward: `${pathname.proposal.attachFiles}`,
    pathNameForward: `${pathname.proposal.responsibleManBasicInfo}`,
  }

  useEffect(() => {
    projectId && handleGetSchema(projectId)
  }, [])

  const handleGetSchema = async (proposalId) => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getInfomaDocumentPage(proposalId)
      setSchema(_schema.model)
      setIsEditWidget({
        property: _schema.forms?.property?.id ? false : true,
      })
      setShowEditAll(!_schema.forms?.property?.disabled)
    } catch (e) {
      setError({})
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleOnUploadSuccess = (res) => {
    console.log(res)
    setSchema((state) => ({
      ...state,
      forms: {
        ...state.forms,
        property: {
          ...state.forms.property,
          attachFiles: res,
        },
      },
    }))
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  return (
    <>
      {schema && (
        <SidebarProposal>
          <ContentHeader header={schema.header} subHeader={schema.subHeader} />

          {schema?.forms?.attachFiles && (
            <InfomaUploadFilesWidget
              schema={schema.forms}
              // onDelete={handleDelete}
              // onUpdate={onUpdate}
              // onDownload={onDownload}
              // onPreview={onPreview}
              onUploadSuccess={(e) => handleOnUploadSuccess(e)}
              //   onUploadError={(e) =>
              //     setIsGranteeFileError(e.response.errorMessage + ' อัพโหลดไม่สำเร็จ')
              //   }
              // isEditErr={isEditErr}
              // isUploadErr={isUploadErr}
              // isDeleteError={isDeleteError}
              // loading={isLoading}
              disabledForm={schema.forms.disabled}
            />
          )}

          <br />
          <br />
          <br />
          <br />
        </SidebarProposal>
      )}
    </>
  )
}

const mockSchema = {
  header: 'การเชื่อมโยงเพื่อจัดเก็บในระบบ INFOMA',
  forms: {
    disabled: false,
    attachFiles: {
      name: 'attachFiles',
      header: ' ',
      value: [
        {
          id: '1',
          category: '01-กลั่นกรองและอนุมัติโครงการ',
          children: [
            {
              id: '13FC976D-6431-41D3-B840-AAF2175CCFA8',
              documentId: '01',
              documentName: 'ข้อเสนอโครงการ',
              enableDelete: true,
              isRequired: true,
              isValidated: false,
              label: 'Screenshot 2566-11-21 at 10.47.45.png',
              name: 'Screenshot 2566-11-21 at 10.47.45.png',
              path: 'proposal/person-qualification/4890B78F-FA09-460C-92B1-D2226B3075A0.png',
              docdocType: '0',
              docTypeLabel: 'ระบบ',
              //IsAdditionalFile: false,
              MasterCategoryId: '1',
            },
            {
              id: '99A859F9-4C82-4E0C-8816-8ACCDBE76691',
              documentId: '02',
              documentName: 'หลักฐานประกอบการยื่นข้อเสนอ',
              enableDelete: true,
              isRequired: true,
              isValidated: false,
              label: 'examplePDF.pdf',
              name: 'examplePDF.pdf',
              path: 'proposal/person-qualification/C15EC836-FC70-46A8-A176-B8E5C8251317.pdf',
              docType: '0',
              docTypeLabel: 'ระบบ',
              IsAdditionalFile: false,
              MasterCategoryId: '1',
            },
            {
              id: 'xxx-03',
              documentId: '03',
              documentName: 'แบบยืนยันการไม่มีส่วนได้ส่วนเสีย อ.7',
              enableDelete: true,
              isRequired: true,
              isValidated: false,
              label: '',
              name: '',
              path: '',
              docType: '0',
              docTypeLabel: 'ระบบ',
              IsAdditionalFile: false,
              MasterCategoryId: '1',
            },
            {
              id: 'xxx-04',
              documentId: '04',
              documentName: 'แบบกลั่นกรองโครงการ อ.8',
              enableDelete: true,
              isRequired: true,
              isValidated: false,
              label: '',
              name: '',
              path: '',
              docType: '0',
              docTypeLabel: 'ระบบ',
              IsAdditionalFile: false,
              MasterCategoryId: '1',
            },
            {
              id: 'xxx-05',
              documentId: '05',
              documentName: 'รายงานการประชุมคณะกรรมการพิจารณาโครงการ',
              enableDelete: true,
              isRequired: true,
              isValidated: false,
              label: '',
              name: '',
              path: '',
              docType: '0',
              docTypeLabel: 'ระบบ',
              IsAdditionalFile: false,
              MasterCategoryId: '1',
            },
            {
              id: 'xxx-06',
              documentId: '06',
              documentName: 'แบบสรุปรายงานการพิจารณาโครงการ',
              enableDelete: true,
              isRequired: true,
              isValidated: false,
              label: '',
              name: '',
              path: '',
              docType: '0',
              docTypeLabel: 'ระบบ',
              IsAdditionalFile: false,
              MasterCategoryId: '1',
            },
            {
              id: 'xxx-07',
              documentId: '07',
              documentName: 'แบบขออนุมัติและจัดทำสัญญา อ.10',
              enableDelete: true,
              isRequired: true,
              isValidated: false,
              label: '',
              name: '',
              path: '',
              docType: '0',
              docTypeLabel: 'ระบบ',
              IsAdditionalFile: false,
              MasterCategoryId: '1',
            },
            {
              id: 'xxx-08',
              documentId: '08',
              documentName: 'รายงานสรุปกรณีมีส่วนได้เสียของโครงการ อ.11',
              enableDelete: true,
              isRequired: true,
              isValidated: false,
              label: '',
              name: '',
              path: '',
              docType: '0',
              docTypeLabel: 'ระบบ',
              IsAdditionalFile: false,
              MasterCategoryId: '1',
            },
            {
              id: 'last',
              documentId: '',
              documentName: '',
              enableDelete: true,
              isRequired: true,
              isValidated: false,
              label: '',
              name: '',
              path: '',
              type: '',
              IsAdditionalFile: false,
              MasterCategoryId: '1',
              isLastRow: true,
            },
          ],
        },
        {
          id: '2',
          category: '02-การจัดทำข้อตกลง',
          children: [
            {
              id: '13FC976D-6431-41D3-B840-AAF2175CCFA8',
              documentId: '01',
              documentName: 'ข้อตกลง / สัญญา (กระดาษ/อิเล็กทรอนิกส์)',
              enableDelete: true,
              isRequired: true,
              isValidated: false,
              label: '',
              name: '',
              path: '',
              docType: '0',
              docTypeLabel: 'ระบบ',
            },
            {
              id: 'xxx-02',
              documentId: '02',
              documentName: 'หลักฐานประกอบการทำสัญญา(เพิ่มเติม)',
              enableDelete: true,
              isRequired: true,
              isValidated: false,
              label: '',
              name: '',
              path: '',
              docType: '0',
              docTypeLabel: 'ระบบ',
            },
            {
              id: 'xxx-03',
              documentId: '03',
              documentName: 'ข้อเสนอโครงการ (ฉบับfinal)',
              enableDelete: true,
              isRequired: true,
              isValidated: false,
              label: '',
              name: '',
              path: '',
              docType: '0',
              docTypeLabel: 'ระบบ',
            },
            {
              id: 'xxx-04',
              documentId: '04',
              documentName: 'รายละเอียดการเบิกจ่ายงบประมาณของโครงการแต่ละงวด',
              enableDelete: true,
              isRequired: true,
              isValidated: false,
              label: '',
              name: '',
              path: '',
              docType: '0',
              docTypeLabel: 'ระบบ',
            },
            {
              id: 'xxx-05',
              documentId: '05',
              documentName: 'เงื่อนไขการรับทุน',
              enableDelete: true,
              isRequired: true,
              isValidated: false,
              label: '',
              name: '',
              path: '',
              docType: '0',
              docTypeLabel: 'ระบบ',
            },
            {
              id: 'xxx-06',
              documentId: '06',
              documentName: 'หนังสือรับรองการรับทุน',
              enableDelete: true,
              isRequired: true,
              isValidated: false,
              label: '',
              name: '',
              path: '',
              docType: '0',
              docTypeLabel: 'ระบบ',
            },
            {
              id: 'xxx-07',
              documentId: '07',
              documentName: 'หน้า Bookbank',
              enableDelete: true,
              isRequired: true,
              isValidated: false,
              label: '',
              name: '',
              path: '',
              docType: '0',
              docTypeLabel: 'ระบบ',
            },
            {
              id: 'xxx-08',
              documentId: '08',
              documentName: 'การชำระอากรแสตมป์',
              enableDelete: true,
              isRequired: true,
              isValidated: false,
              label: '',
              name: '',
              path: '',
              docType: '0',
              docTypeLabel: 'ระบบ',
            },
            {
              id: 'xxx-09',
              documentId: '09',
              documentName: 'ข้อตกลงการประมวลผลข้อมูลส่วนบุคคล DPA',
              enableDelete: true,
              isRequired: true,
              isValidated: false,
              label: '',
              name: '',
              path: '',
              docType: '0',
              docTypeLabel: 'ระบบ',
            },
          ],
        },
        {
          id: '3',
          category: '03-การแก้ไขข้อตกลง',
          children: [
            {
              id: '13FC976D-6431-41D3-B840-AAF2175CCFA8',
              documentId: '01',
              documentName: 'ข้อตกลง / สัญญา (ฉบับแก้ไข)(กระดาษ/อิเล็กทรอนิกส์)',
              enableDelete: true,
              isRequired: true,
              isValidated: false,
              label: '',
              name: '',
              path: '',
              docType: '0',
              docTypeLabel: 'ระบบ',
            },
            {
              id: 'xxx-02',
              documentId: '02',
              documentName: 'หนังสือขอแก้ไข (จากภาคี)',
              enableDelete: true,
              isRequired: true,
              isValidated: false,
              label: '',
              name: '',
              path: '',
              docType: '0',
              docTypeLabel: 'ระบบ',
            },
            {
              id: 'xxx-03',
              documentId: '03',
              documentName: 'หนังสือมอบอำนาจ',
              enableDelete: true,
              isRequired: true,
              isValidated: false,
              label: '',
              name: '',
              path: '',
              docType: '0',
              docTypeLabel: 'ระบบ',
            },
            {
              id: 'xxx-04',
              documentId: '04',
              documentName: 'หนังสือแต่งตั้งผู้รับผิดชอบโครการ',
              enableDelete: true,
              isRequired: true,
              isValidated: false,
              label: '',
              name: '',
              path: '',
              docType: '0',
              docTypeLabel: 'ระบบ',
            },
            {
              id: 'xxx-05',
              documentId: '05',
              documentName: 'คำสั่งแต่งตั้ง',
              enableDelete: true,
              isRequired: true,
              isValidated: false,
              label: '',
              name: '',
              path: '',
              docType: '0',
              docTypeLabel: 'ระบบ',
            },
            {
              id: 'xxx-06',
              documentId: '06',
              documentName: 'สำนาบัตรประชาชน',
              enableDelete: true,
              isRequired: true,
              isValidated: false,
              label: '',
              name: '',
              path: '',
              docType: '0',
              docTypeLabel: 'ระบบ',
            },
            {
              id: 'xxx-07',
              documentId: '07',
              documentName: 'ฯลฯ',
              enableDelete: true,
              isRequired: true,
              isValidated: false,
              label: '',
              name: '',
              path: '',
              docType: '0',
              docTypeLabel: 'ระบบ',
            },
          ],
        },
        {
          id: '4',
          category: '04-การเบิกเงิน งวดที่ 1',
          children: [
            {
              id: '13FC976D-6431-41D3-B840-AAF2175CCFA8',
              documentId: '01',
              documentName: 'แบบขอเบิกเงินโครงการ f-008 (เลขที่หนังสือภายใน)',
              enableDelete: true,
              isRequired: true,
              isValidated: false,
              label: '',
              name: '',
              path: '',
              docType: '0',
              docTypeLabel: 'ระบบ',
            },
            {
              id: 'xxx-02',
              documentId: '02',
              documentName: 'หน้าบุ๊คแบงค์  ',
              enableDelete: true,
              isRequired: true,
              isValidated: false,
              label: '',
              name: '',
              path: '',
              docType: '0',
              docTypeLabel: 'ระบบ',
            },
            {
              id: 'xxx-03',
              documentId: '03',
              documentName: 'แบบขออนุมัติจัดทำสัญญา อ.10 ',
              enableDelete: true,
              isRequired: true,
              isValidated: false,
              label: '',
              name: '',
              path: '',
              docType: '0',
              docTypeLabel: 'ระบบ',
            },
            {
              id: 'xxx-04',
              documentId: '04',
              documentName: 'หลักฐานการได้รับการยกเว้นภาษี',
              enableDelete: true,
              isRequired: true,
              isValidated: false,
              label: '',
              name: '',
              path: '',
              docType: '0',
              docTypeLabel: 'ระบบ',
            },
            {
              id: 'xxx-05',
              documentId: '05',
              documentName: 'ใบทะเบียนภาษีมูลค่าเพิ่ม ภพ.20',
              enableDelete: true,
              isRequired: true,
              isValidated: false,
              label: '',
              name: '',
              path: '',
              docType: '0',
              docTypeLabel: 'ระบบ',
            },
            {
              id: 'xxx-06',
              documentId: '06',
              documentName: 'ใบ PV (1 PV เบิกจ่ายหลายโครงการ/หลายสำนัก)',
              enableDelete: true,
              isRequired: true,
              isValidated: false,
              label: '',
              name: '',
              path: '',
              docType: '0',
              docTypeLabel: 'ระบบ',
            },
            {
              id: 'xxx-07',
              documentId: '07',
              documentName: 'ใบสำคัญตั้งหนี้บริหารโครงการ',
              enableDelete: true,
              isRequired: true,
              isValidated: false,
              label: '',
              name: '',
              path: '',
              docType: '0',
              docTypeLabel: 'ระบบ',
            },
          ],
        },
        {
          id: '4-1',
          category: '04-การเบิกเงิน งวดที่ N…',
          children: [
            {
              id: '13FC976D-6431-41D3-B840-AAF2175CCFA8',
              documentId: '01',
              documentName: 'รายงานการเงิน งวดก่อนหน้า ',
              enableDelete: true,
              isRequired: true,
              isValidated: false,
              label: '',
              name: '',
              path: '',
              docType: '0',
              docTypeLabel: 'ระบบ',
            },
            {
              id: 'xxx-02',
              documentId: '02',
              documentName: 'แบบขอเบิกเงินโครงการ f-008',
              enableDelete: true,
              isRequired: true,
              isValidated: false,
              label: '',
              name: '',
              path: '',
              docType: '0',
              docTypeLabel: 'ระบบ',
            },
            {
              id: 'xxx-03',
              documentId: '03',
              documentName: 'รายงานความก้าวหน้าในงวดนั้น ๆ',
              enableDelete: true,
              isRequired: true,
              isValidated: false,
              label: '',
              name: '',
              path: '',
              docType: '0',
              docTypeLabel: 'ระบบ',
            },
            {
              id: 'xxx-04',
              documentId: '04',
              documentName: 'หน้าบุ๊คแบงค์',
              enableDelete: true,
              isRequired: true,
              isValidated: false,
              label: '',
              name: '',
              path: '',
              docType: '0',
              docTypeLabel: 'ระบบ',
            },
            {
              id: 'xxx-05',
              documentId: '05',
              documentName: 'ขอนำส่งเอกสารรับรองการตรวจสอบเงินงวดโครงการ',
              enableDelete: true,
              isRequired: true,
              isValidated: false,
              label: '',
              name: '',
              path: '',
              docType: '0',
              docTypeLabel: 'ระบบ',
            },
            {
              id: 'xxx-06',
              documentId: '06',
              documentName: 'รายงานสรุปประกอบการขออนุมัติเบิกเงินงวดนั้น',
              enableDelete: true,
              isRequired: true,
              isValidated: false,
              label: '',
              name: '',
              path: '',
              docType: '0',
              docTypeLabel: 'ระบบ',
            },
            {
              id: 'xxx-07',
              documentId: '07',
              documentName: 'Teller Payment',
              enableDelete: true,
              isRequired: true,
              isValidated: false,
              label: '',
              name: '',
              path: '',
              docType: '0',
              docTypeLabel: 'ระบบ',
            },
            {
              id: 'xxx-08',
              documentId: '08',
              documentName: 'แผนการใช้จ่ายงบประมาณ',
              enableDelete: true,
              isRequired: true,
              isValidated: false,
              label: '',
              name: '',
              path: '',
              docType: '0',
              docTypeLabel: 'ระบบ',
            },
            {
              id: 'xxx-09',
              documentId: '09',
              documentName: 'หลักฐานการได้รับยกเว้นภาษี ',
              enableDelete: true,
              isRequired: true,
              isValidated: false,
              label: '',
              name: '',
              path: '',
              docType: '0',
              docTypeLabel: 'ระบบ',
            },
            {
              id: 'xxx-10',
              documentId: '10',
              documentName: 'ใบทะเบียนภาษีมูลค่าเพิ่ม ภพ.20',
              enableDelete: true,
              isRequired: true,
              isValidated: false,
              label: '',
              name: '',
              path: '',
              docType: '0',
              docTypeLabel: 'ระบบ',
            },
            {
              id: 'xxx-11',
              documentId: '11',
              documentName: 'ใบ PV (1 PV เบิกจ่ายหลายโครงการ/หลายสำนัก)',
              enableDelete: true,
              isRequired: true,
              isValidated: false,
              label: '',
              name: '',
              path: '',
              docType: '0',
              docTypeLabel: 'ระบบ',
            },
            {
              id: 'xxx-12',
              documentId: '12',
              documentName: 'ใบสำคัญตั้งหนี้บริหารโครงการ',
              enableDelete: true,
              isRequired: true,
              isValidated: false,
              label: '',
              name: '',
              path: '',
              docType: '0',
              docTypeLabel: 'ระบบ',
            },
          ],
        },
        {
          id: '5',
          category: '05-การเปลี่ยนแปลง/ขยายเวลา',
          children: [
            {
              id: '13FC976D-6431-41D3-B840-AAF2175CCFA8',
              documentId: '01',
              documentName: 'หนังสือติดตามงาน',
              enableDelete: true,
              isRequired: true,
              isValidated: false,
              label: '',
              name: '',
              path: '',
              docType: '0',
              docTypeLabel: 'ระบบ',
            },
            {
              id: 'xxx-02',
              documentId: '02',
              documentName: 'หนังสือขอขยายระยะเวลา/เปลี่ยนแปลงโครงการ',
              enableDelete: true,
              isRequired: true,
              isValidated: false,
              label: '',
              name: '',
              path: '',
              docType: '0',
              docTypeLabel: 'ระบบ',
            },
          ],
        },
        {
          id: '6',
          category: '06-การปิดโครงการ',
          children: [
            {
              id: '13FC976D-6431-41D3-B840-AAF2175CCFA8',
              documentId: '01',
              documentName: 'รายงานฉบับสมบูรณ์',
              enableDelete: true,
              isRequired: true,
              isValidated: false,
              label: '',
              name: '',
              path: '',
              docType: '0',
              docTypeLabel: 'ระบบ',
            },
            {
              id: 'xxx-02',
              documentId: '02',
              documentName: 'หน้าสมุดบัญชี (ตั้งแต่หน้าแรกจนถึงหน้าสุดท้ายที่มีรายการเคลื่อนไหว)',
              enableDelete: true,
              isRequired: true,
              isValidated: false,
              label: '',
              name: '',
              path: '',
              docType: '0',
              docTypeLabel: 'ระบบ',
            },
            {
              id: 'xxx-03',
              documentId: '03',
              documentName: 'รายงานการเงิน (งวดก่อนหน้าและงวดปัจจุบัน)',
              enableDelete: true,
              isRequired: true,
              isValidated: false,
              label: '',
              name: '',
              path: '',
              docType: '0',
              docTypeLabel: 'ระบบ',
            },
            {
              id: 'xxx-04',
              documentId: '04',
              documentName: 'เอกสารแนบรายงานสรุปเพื่อขออนุมัติปิดโครงการ',
              enableDelete: true,
              isRequired: true,
              isValidated: false,
              label: '',
              name: '',
              path: '',
              docType: '0',
              docTypeLabel: 'ระบบ',
            },
            {
              id: 'xxx-05',
              documentId: '05',
              documentName: 'teller payment/ใบ Pay IN',
              enableDelete: true,
              isRequired: true,
              isValidated: false,
              label: '',
              name: '',
              path: '',
              docType: '0',
              docTypeLabel: 'ระบบ',
            },
          ],
        },
        {
          id: '7',
          category: '07-การยุติโครงการ',
          children: [
            {
              id: '13FC976D-6431-41D3-B840-AAF2175CCFA8',
              documentId: '01',
              documentName: 'รายงานสรุปเพื่อขออนุมัติยุติโครงการ',
              enableDelete: true,
              isRequired: true,
              isValidated: false,
              label: '',
              name: '',
              path: '',
              docType: '0',
              docTypeLabel: 'ระบบ',
            },
            {
              id: 'xxx-02',
              documentId: '02',
              documentName: 'เอกสารแนบรายงานสรุปเพื่อขออนุมัติยุติโครงการ',
              enableDelete: true,
              isRequired: true,
              isValidated: false,
              label: '',
              name: '',
              path: '',
              docType: '0',
              docTypeLabel: 'ระบบ',
            },
            {
              id: 'xxx-03',
              documentId: '03',
              documentName: 'รายงานฉบับสมบูรณ์',
              enableDelete: true,
              isRequired: true,
              isValidated: false,
              label: '',
              name: '',
              path: '',
              docType: '0',
              docTypeLabel: 'ระบบ',
            },
            {
              id: 'xxx-04',
              documentId: '04',
              documentName: 'หน้าสมุดบัญชี (ตั้งแต่หน้าแรกจนถึงหน้าสุดท้าย)',
              enableDelete: true,
              isRequired: true,
              isValidated: false,
              label: '',
              name: '',
              path: '',
              docType: '0',
              docTypeLabel: 'ระบบ',
            },
            {
              id: 'xxx-05',
              documentId: '05',
              documentName: 'รายงานการเงิน (งวดก่อนหน้า)',
              enableDelete: true,
              isRequired: true,
              isValidated: false,
              label: '',
              name: '',
              path: '',
              docType: '0',
              docTypeLabel: 'ระบบ',
            },
            {
              id: 'xxx-06',
              documentId: '06',
              documentName: 'หนังสือขอยุติโครงการ',
              enableDelete: true,
              isRequired: true,
              isValidated: false,
              label: '',
              name: '',
              path: '',
              docType: '0',
              docTypeLabel: 'ระบบ',
            },
            {
              id: 'xxx-07',
              documentId: '07',
              documentName: 'สมุดบัญชีที่ปิดโครงการ  ',
              enableDelete: true,
              isRequired: true,
              isValidated: false,
              label: '',
              name: '',
              path: '',
              docType: '0',
              docTypeLabel: 'ระบบ',
            },
            {
              id: 'xxx-08',
              documentId: '08',
              documentName: 'teller payment/ใบ Pay IN',
              enableDelete: true,
              isRequired: true,
              isValidated: false,
              label: '',
              name: '',
              path: '',
              docType: '0',
              docTypeLabel: 'ระบบ',
            },
          ],
        },
      ],
    },
  },
}
